var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hint-block" }, [
    _c(
      "div",
      {
        staticClass: "title",
        on: {
          click: function($event) {
            _vm.hintOpened = !_vm.hintOpened
          }
        }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _c("chevron-animated", { attrs: { reverse: _vm.hintOpened } })
      ],
      1
    ),
    _c("div", { class: ["description", { opened: _vm.hintOpened }] }, [
      _vm._v("\n    " + _vm._s(_vm.description)),
      _c("br"),
      _vm.secondary
        ? _c("div", [
            _c("span", [_vm._v("Расположение:")]),
            _vm._v("\n      " + _vm._s(_vm.secondary) + "\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }